import { render } from "./InformeInter_DiagInter.vue?vue&type=template&id=ac5bd5c2&scoped=true"
import script from "./InformeInter_DiagInter.vue?vue&type=script&lang=js"
export * from "./InformeInter_DiagInter.vue?vue&type=script&lang=js"

import "./InformeInter_DiagInter.vue?vue&type=style&index=0&id=ac5bd5c2&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=1&id=ac5bd5c2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5bd5c2"]])

export default __exports__